module.exports = __webpack_public_path__ + "media/fenfa.f6a1fad3.mp4";